<template>
    <v-container>
        <page-header title="Rules" icon="mdi-police-badge-outline" />
        <v-card class="form-card" elevation="1">
            <div v-for="i in 7" :key="i">
                <v-row align="center">
                    <v-col cols="8">
                        <v-text-field
                            v-if="i === 1"
                            v-model="noOfMatches"
                            outlined
                            dense
                            hide-details
                            :label="`#MatchesRule${i}`"
                            type="number"
                        />
                        <v-text-field
                            v-else-if="i === 2"
                            v-model="noOfMatches2"
                            outlined
                            dense
                            hide-details
                            :label="`#MatchesRule${i}`"
                            type="number"
                        />
                        <v-text-field
                            v-else-if="i === 3"
                            v-model="noOfMatches3"
                            outlined
                            dense
                            hide-details
                            :label="`#MatchesRule${i}`"
                            type="number"
                        />
                        <v-select
                            v-else-if="i === 4"
                            v-model="activePhase"
                            outlined
                            dense
                            hide-details
                            :items="['placements', 'regular_season', 'playoffs']"
                            menu-props="auto"
                            label="Active Phase"
                            :clearable="!readOnly"
                        />
                        <v-select
                            v-else-if="i === 5"
                            v-model="activeSeason"
                            outlined
                            dense
                            hide-details
                            :items="seasons"
                            :item-text="(item) => `${item.year} - ${item.type}`"
                            menu-props="auto"
                            label="Active Season"
                            :clearable="!readOnly"
                            return-object
                        />
                        <v-text-field
                            v-else-if="i === 6"
                            v-model="postponementsPerTeam"
                            outlined
                            dense
                            hide-details
                            label="Postponements per team (per season)"
                            type="number"
                            min="0"
                        />
                        <v-text-field
                            v-else
                            v-model="postponementDeadlineHours"
                            outlined
                            dense
                            hide-details
                            label="Postponement deadline (hours before the match)"
                            type="number"
                            min="0"
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-btn :loading="loading" class="white--text" depressed color="black" @click="editRegulation(i)">
                            <v-icon left small>mdi-content-save-outline</v-icon>Save
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import PageHeader from '@/components/PageHeader'
    import configService from '@/services/config'
    import Alert from '@/components/Alert'
    import seasonService from '@/services/season'

    export default {
        name: 'RulesForm',
        components: { Alert, PageHeader },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                readOnly: false,
                clearable: true,
                loading: false,
                noOfMatches: 0,
                noOfMatches2: 0,
                noOfMatches3: 0,
                activeSeason: null,
                activePhase: null,
                postponementsPerTeam: 0,
                postponementDeadlineHours: 24,
                seasons: [],
                rules: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        created() {
            // the seasons first: the active one is looked up among them
            this.fetchAllSeasons().then(() => configService.getConfig()).then(resp => {
                this.noOfMatches = resp.data.noOfMatches
                this.noOfMatches2 = resp.data.noOfMatches2
                this.noOfMatches3 = resp.data.noOfMatches3
                this.activePhase = resp.data.activePhase
                this.postponementsPerTeam = resp.data.postponementsPerTeam
                this.postponementDeadlineHours = resp.data.postponementDeadlineHours
                this.activeSeason = resp.data.activeSeasonId ? (this.seasons.find(season => season.id === resp.data.activeSeasonId) || null) : null
            }).catch((error) => {
                this.setAlert(error.response && error.response.data ? error.response.data.message : 'Could not load the rules', 'error')
            })
            // configService.getConfigField('noOfMatches1').then(resp => {
            //     this.noOfMatches1 = resp.data
            // })
            // configService.getConfigField('noOfMatches2').then(resp => {
            //     this.noOfMatches2 = resp.data
            // })
            // configService.getConfigField('noOfMatches3').then(resp => {
            //     this.noOfMatches3 = resp.data
            // })
            // configService.getConfigField('activePhase').then(resp => {
            //     this.activePhase = resp.data
            // })
            // configService.getConfigField('activeSeason').then(resp => {
            //     this.activeSeason = resp.data
            // })
        },
        methods: {
            fetchAllSeasons() {
                return seasonService.getSeasons(1, 100).then(resp => {
                    this.seasons = resp.data.content
                }).catch((error) => {
                    this.setAlert(error.response && error.response.data ? error.response.data.message : 'Could not load the seasons', 'error')
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            editRegulation(id) {
                let field = ''
                let value = ''
                if (id === 1) {
                    field = 'noOfMatches1'
                    value = { 'noOfMatches1': this.noOfMatches }
                } else if (id === 2) {
                    field = 'noOfMatches2'
                    value = { 'noOfMatches2': this.noOfMatches2 }
                } else if (id === 3) {
                    field = 'noOfMatches3'
                    value = { 'noOfMatches3': this.noOfMatches3 }
                } else if (id === 4) {
                    field = 'activePhase'
                    value = { 'activePhase': this.activePhase }
                } else if (id === 5) {
                    if (!this.activeSeason) {
                        this.setAlert('Choose a season first', 'error')
                        return
                    }
                    field = 'activeSeasonId'
                    value = { 'activeSeasonId': this.activeSeason.id }
                } else if (id === 6) {
                    field = 'postponementsPerTeam'
                    value = { 'postponementsPerTeam': Number(this.postponementsPerTeam) || 0 }
                } else if (id === 7) {
                    field = 'postponementDeadlineHours'
                    value = { 'postponementDeadlineHours': Number(this.postponementDeadlineHours) || 0 }
                }
                this.loading = true
                configService.updateConfigField(field, value).then(resp => {
                    this.loading = false
                    this.setAlert(`${field} updated successfully`, 'success')
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response && error.response.data ? error.response.data.message : `Could not update ${field}`, 'error')
                })
            }
        }
    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

</style>
